import { VaultedSecretAccess } from "@p0security/integrations-vaulted-credential-shared";
import { Access } from "@p0security/shared/types/access/index";

export const MongodbAtlasAiAccesses = {
  permission: Access({
    description:
      "Roles in a MongoDB Atlas project, granted via a shared NHI credential",
    label: "Permission",
    maturity: "beta",
    ...VaultedSecretAccess,
    parameters: {
      project: {
        type: "dynamic",
        label: "Project",
        description: "MongoDB Atlas project",
      },
      // Values are Atlas project roles (e.g. "GROUP_DATA_ACCESS_READ_ONLY").
      policies: {
        type: "dynamic",
        label: "Roles",
        description: "Project roles to grant",
        multivalued: true,
      },
    },
    render: {
      locator: "project",
      policy: "policies",
    } as const,
  }),
};

export type MongodbAtlasAiAccesses = typeof MongodbAtlasAiAccesses;
export type MongodbAtlasAiAccess =
  MongodbAtlasAiAccesses[keyof MongodbAtlasAiAccesses];
export type MongodbAtlasAiPermissionAccess =
  MongodbAtlasAiAccesses["permission"];
